import { createContext } from 'react';

var ScheduleContext = /*#__PURE__*/createContext({
  startTime: null,
  endTime: null
});

export { ScheduleContext };
//# sourceMappingURL=contexts.js.map
